import Actions from '../../odata/actions';

const actions = new Actions('companySetting', 'companySettings');

export default actions;
